import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './ListViewFilterViewSpacingWrapper.module.scss'

interface ListViewFilterViewSpacingWrapperProps {
  children: ReactNode
  view?: 'list' | 'filter'
}
export const ListViewFilterViewSpacingWrapper = (
  props: ListViewFilterViewSpacingWrapperProps
) => (
  <div
    className={classNames({
      [styles.wrapper]: true,
      [styles.filterView]: props.view === 'filter',
      [styles.listView]: props.view === 'list',
    })}
  >
    {props.children}
  </div>
)
